import React from "react";

export const LazyBrokersMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./BrokersMultiSelectAutoUpdate"
        )
);
